// kware start edit - Offline Operations: Batch processor
// REASON: Executes offline operations sequentially against FOLIO circulation APIs.
// buildComment is passed from parent to avoid rebuilding on every call.
// - Check Out / Renew: comment via overrideBlocks.comment
// - Check In: comment via POST /circulation/loans/{id}/add-info after check-in

import { OPERATION_TYPES } from './ExcelParser';

const BATCH_DELAY_MS = 300;

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const processBatch = async (operations, { mutator, servicePointId, buildComment }) => {
  const results = [];

  for (const op of operations) {
    await sleep(BATCH_DELAY_MS);

    try {
      const comment = buildComment(op);
      let result;

      if (op.type === OPERATION_TYPES.CHECK_OUT) {
        result = await mutator.checkOut.POST({
          itemBarcode: op.itemBarcode,
          userBarcode: op.patronBarcode,
          servicePointId,
          loanDate: op.actionDate,
          overrideBlocks: { comment },
        });

      } else if (op.type === OPERATION_TYPES.CHECK_IN) {
        result = await mutator.checkIn.POST({
          itemBarcode: op.itemBarcode,
          servicePointId,
          checkInDate: op.actionDate,
        });

        const loanId = result?.loan?.id;
        if (loanId) {
          await sleep(200);
          await mutator.addInfo.POST(
            { action: 'staffInfoAdded', actionComment: comment },
            { path: `circulation/loans/${loanId}/add-info` }
          );
        }

      } else if (op.type === OPERATION_TYPES.RENEW) {
        result = await mutator.renew.POST({
          itemBarcode: op.itemBarcode,
          userBarcode: op.patronBarcode,
          servicePointId,
          overrideBlocks: { comment },
        });
      }

      results.push({ ...op, status: 'success', result });
    } catch (err) {
      let errorMessage = 'Unknown error';
      try {
        const body = typeof err.json === 'function' ? await err.json() : err;
        errorMessage = body?.errors?.[0]?.message || body?.message || JSON.stringify(body);
      } catch {
        errorMessage = err.message || String(err);
      }
      results.push({ ...op, status: 'error', errorMessage });
    }
  }

  return results;
};
// kware end edit
